import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

export type PipeReviewDashboard = {
  dryingEvent1: WidgetData;
  dryingEvent2: WidgetData;
};

type WidgetData = {
  countApproved: number;
  countRejected: number;
  countOverdue: number;
  countResult: number;
  countInReview: number;
};

const usePipeReviewWidgetQuery = (seasonTypeId?: string) => {
  const query = useQuery<AxiosResponse<PipeReviewDashboard>>({
    queryKey: ['pipe-review-dashboard', seasonTypeId],
    queryFn: () => API.get('/mrvresources/dashboard', {
      params: { 'seasonTypeId.equals': seasonTypeId },
    }),
    refetchOnWindowFocus: false,
  });

  return query;
};

export default usePipeReviewWidgetQuery;
